import { put, call } from 'redux-saga/effects';
import {
  getLanguagesRequestError,
  getLanguagesRequestSuccess,
  // translationSelectors,
} from '../../../reducers/translationSlice';

import { api } from '../../../api/lelyBackend/translationApi';
// import fetchTranslations from '../../i18n/fetchTranslationsSaga';
import withLoading from '../../../sagas/loadingSaga';

export default function* getLanguagesRequest() {
  try {
    // eslint-disable-next-line func-names
    yield* withLoading(function* () {
      const allLanguageDetails = yield call(api.getLanguages);
      const languagePreferenceResponse = allLanguageDetails.data;
      yield put(getLanguagesRequestSuccess(languagePreferenceResponse));

      // // Get preferred language from state
      // const preferredLanguage = yield select(
      //   translationSelectors.selectPreferredLanguageCode,
      // );

      // // Fetch translations for the preferred language
      // return [call(fetchTranslations, preferredLanguage)];
    });
  } catch (error: any) {
    yield put(getLanguagesRequestError(error));
  }
}
